exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fill-gray {\n    background-size: cover;\n    background-color: #f0f0f5;\n    margin-left: 5;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/content-tile-invalid/content-tile-invalid.component.css
// module id = 817
// module chunks = 0